export default "__VITE_ASSET__DFGVUKHz__"